export const articles = [
  {
    id: 1,
    title: '2024年最值得期待的十部国产剧，每一部都是爆款预定',
    category: 'dianshiju',
    categoryName: '电视剧',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20TV%20drama%20collage%20poster%20style%20with%20multiple%20drama%20scenes%2C%20warm%20cinematic%20lighting%2C%20elegant%20composition%2C%20entertainment%20news%20theme&width=800&height=450&seq=article-01&orientation=landscape',
    excerpt: '随着国产剧制作水平的不断提升，2024年将有一大批精品剧集与观众见面。本文为你盘点今年最值得期待的十部国产电视剧。',
    content: `## 国产剧市场迎来黄金时代

近年来，国产电视剧的质量和口碑都有了显著提升。从《繁花》到《庆余年》，从《狂飙》到《漫长的季节》，精品剧集层出不穷。

### 2024年度十大期待剧集

#### 1. 《庆余年第二季》
作为现象级IP的续作，第二季延续了第一季的高水准制作。范闲的身世之谜、京都的权力斗争都将更加激烈。

#### 2. 《长风渡》
古装商战与爱情结合，白敬亭和宋轶的二次搭档引发观众期待。

#### 3. 《与凤行》
赵丽颖和林更新的仙侠大作，特效和服化道都达到了国产剧新高度。

### 国产剧品质提升的关键因素

- **剧本为王**：越来越多的制作方重视剧本创作
- **演员实力**：流量退潮，实力派演员迎来春天
- **制作升级**：服化道、特效、摄影全面升级

> "好的内容永远不缺观众，国产剧的黄金时代才刚刚开始。"

2024年注定是国产剧蓬勃发展的一年，让我们一起期待更多优秀作品的诞生。`,
    publishDate: '2024-07-15',
    author: '影视观察员',
    readCount: 12580,
    relatedVideos: [1, 2, 3],
  },
  {
    id: 2,
    title: '《流浪地球3》观影指南：你需要知道的前情提要和看点分析',
    category: 'dianying',
    categoryName: '电影',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20sci-fi%20movie%20review%20article%20header%20image%20with%20space%20theme%2C%20futuristic%20earth%2C%20cinematic%20composition%2C%20dramatic%20cosmic%20background%2C%20film%20critic%20style&width=800&height=450&seq=article-02&orientation=landscape',
    excerpt: '《流浪地球3》终于上映了！作为中国科幻电影的里程碑系列，第三部带来了更多震撼的视效和深刻的人文思考。',
    content: `## 中国科幻的新高度

《流浪地球3》延续了前两部的宏大叙事，在视觉效果和故事深度上都达到了新的高度。

### 故事背景

在第二部的基础上，地球已经离开太阳系，踏上了漫长的星际流浪之旅。然而，新的危机正在酝酿。

### 三大看点

#### 1. 视觉奇观再升级
本片采用了最新的虚拟制作技术，太空场景和行星发动机的呈现更加震撼。

#### 2. 情感内核更深刻
在宏大的科幻背景下，影片探讨了人类在面对存亡危机时的抉择与牺牲。

#### 3. 中国式科幻哲学
不同于好莱坞个人英雄主义，"带着家园去流浪"体现了中国文化的独特思考。

### 观影建议

- 建议选择IMAX或巨幕厅观看
- 片尾有彩蛋，不要提前离场
- 适合全家观影，但低龄儿童可能需要家长引导

《流浪地球3》不仅是一部科幻电影，更是中国电影工业实力的集中展示。`,
    publishDate: '2025-02-20',
    author: '电影评论家',
    readCount: 28340,
    relatedVideos: [4],
  },
  {
    id: 3,
    title: '国漫崛起：从《斗罗大陆》到《完美世界》，3D动画的进阶之路',
    category: 'dongman',
    categoryName: '动漫',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%203D%20animation%20art%20style%20collage%2C%20multiple%20anime%20characters%2C%20fantasy%20theme%2C%20vibrant%20colors%2C%20dynamic%20poses%2C%20digital%20art%20style&width=800&height=450&seq=article-03&orientation=landscape',
    excerpt: '近年来，国产3D动画发展迅猛，从建模质量到动作捕捉，再到剧情改编，都有了质的飞跃。',
    content: `## 国产3D动画的发展历程

从最初的技术探索到如今的精品频出，国产3D动画走过了一条不平凡的道路。

### 技术突破

#### 建模与渲染
国产3D动画的建模水准已经达到了国际先进水平。以《斗罗大陆》为例，角色建模细腻，场景宏大。

#### 动作捕捉
越来越多的国漫采用动作捕捉技术，让人物动作更加自然流畅。

#### 特效升级
战斗场面的特效制作越来越精良，粒子效果和光影表现令人惊艳。

### 代表作品

- **《斗罗大陆》系列**：开创了年番模式的先河
- **《完美世界》**：宏大世界观与热血战斗的完美结合
- **《凡人修仙传》**：写实风格的代表作

> 国漫的未来在于持续创新和对品质的追求，我们正在见证一个新时代的开启。

从技术追随到自主创新，国产3D动画正在书写属于自己的精彩篇章。`,
    publishDate: '2024-06-10',
    author: '动漫达人',
    readCount: 9670,
    relatedVideos: [7, 8],
  },
  {
    id: 4,
    title: '综艺节目新趋势：从竞技到治愈，观众想看什么？',
    category: 'zongyi',
    categoryName: '综艺',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20variety%20show%20behind%20scenes%20style%20image%2C%20colorful%20studio%20set%2C%20group%20of%20entertainers%2C%20warm%20lighting%2C%20energetic%20atmosphere%2C%20entertainment%20production%20theme&width=800&height=450&seq=article-04&orientation=landscape',
    excerpt: '综艺市场正在经历一场深刻的变革，观众的口味从单纯追求刺激转向了对温暖治愈内容的渴望。',
    content: `## 综艺市场的转型之路

2024年的综艺市场呈现出明显的"治愈系"趋势，慢综艺、生活类节目越来越受欢迎。

### 市场变化

#### 竞技类降温
曾经大火的竞技类综艺，收视率和讨论度都有所下滑。

#### 慢综艺崛起
以《向往的生活》为代表的慢综艺，用温馨日常打动观众。

#### 文化类出圈
文化探索类节目开始获得年轻观众的喜爱。

### 观众需求洞察

1. **情感共鸣**：希望在节目中找到情感寄托
2. **真实自然**：讨厌过度剧本化和表演
3. **知识获取**：希望在娱乐中有所收获

综艺的未来不在于更刺激，而在于更走心。`,
    publishDate: '2024-08-05',
    author: '综艺观察',
    readCount: 5420,
    relatedVideos: [9],
  },
  {
    id: 5,
    title: '《舌尖上的中国5》回归：美食纪录片为何经久不衰？',
    category: 'jilupian',
    categoryName: '纪录片',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20food%20documentary%20article%20image%20with%20traditional%20cooking%20scene%2C%20steaming%20wok%2C%20fresh%20ingredients%2C%20warm%20kitchen%20atmosphere%2C%20artistic%20food%20photography&width=800&height=450&seq=article-05&orientation=landscape',
    excerpt: '时隔多年，《舌尖上的中国》第五季终于回归。这部现象级美食纪录片为何能够持续打动观众？',
    content: `## 美食纪录片的永恒魅力

《舌尖上的中国》系列是中国纪录片史上的一个奇迹。从第一季到现在，它始终保持着极高的关注度和口碑。

### 成功密码

#### 人间烟火气
每一道美食背后，都有一个普通人的故事。正是这些平凡而真实的人间烟火，打动了亿万观众。

#### 文化寻根
通过食物，我们找到了自己的文化归属感。舌尖上的中国，也是文化中的中国。

#### 极致制作
精美的摄影、细腻的叙事、恰到好处的配乐，每一帧都是艺术品。

### 第五季亮点

本季将深入更多少数民族地区和非遗美食，视野更加广阔。

> 食物不仅是果腹之物，更是情感的纽带、文化的载体。

《舌尖上的中国5》再次证明，好的内容永远不会过时。`,
    publishDate: '2024-09-01',
    author: '纪录片爱好者',
    readCount: 7890,
    relatedVideos: [10],
  },
  {
    id: 6,
    title: '极速影视平台使用指南：如何享受最流畅的观影体验',
    category: 'news',
    categoryName: '平台资讯',
    coverImage: 'https://readdy.ai/api/search-image?query=Modern%20home%20theater%20setup%20with%20large%20TV%20screen%2C%20cozy%20living%20room%2C%20warm%20ambient%20lighting%2C%20streaming%20device%2C%20comfortable%20sofa%2C%20cinematic%20home%20experience&width=800&height=450&seq=article-06&orientation=landscape',
    excerpt: '想要在极速影视上获得最佳观影体验？本文为你详细介绍平台的各项功能和使用技巧。',
    content: `## 极速影视观看指南

极速影视致力于为用户提供极速不缓冲的高清在线观看体验。以下是使用平台的几个小技巧。

### 核心优势

#### 秒开即播
得益于先进的CDN加速技术，视频几乎可以实现秒开，告别漫长的缓冲等待。

#### 高清画质
支持1080P甚至4K画质，在保证流畅的前提下提供最佳视觉效果。

#### 多端同步
手机、平板、电脑无缝切换，随时随地追剧。

### 使用技巧

1. **选择合适画质**：根据网络状况选择合适的清晰度
2. **收藏功能**：将喜欢的剧集加入收藏，方便下次快速找到
3. **观看历史**：自动记录观看进度，断点续播

希望每位用户都能在极速影视获得愉快的观影体验！`,
    publishDate: '2024-07-01',
    author: '极速影视团队',
    readCount: 15230,
    relatedVideos: [],
  },
];

export const getArticlesByCategory = (categorySlug: string) => {
  return articles.filter((a) => a.category === categorySlug);
};

export const getArticleById = (id: number) => {
  return articles.find((a) => a.id === id);
};

export const getLatestArticles = (count: number = 3) => {
  return [...articles].sort((a, b) => new Date(b.publishDate).getTime() - new Date(a.publishDate).getTime()).slice(0, count);
};